import { ButtonMedium } from '@components/core-ui/form-elements/buttons/Button/variations/PrimaryButtonSizes';
import { routes } from '@routes';

import PositiveIcon from 'app/components/icons/Positive.svg';
import React from 'react';
import { useNavigate } from 'react-router';
import { Wrapper } from './styles';
import { StyledIconWrapper } from './styles/StyledIconWrapper';

export const RegistrationSuccessPage = () => {
  const navigate = useNavigate();

  const urlSearchParams = new URLSearchParams(location.search);
  const email = urlSearchParams.get('email');
  const goto = urlSearchParams.get('goto');

  const goToLogin = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    if (goto) {
      navigate(`${routes.signin.make()}?${new URLSearchParams({ goto, email: email ?? '' }).toString()}`);
      return;
    }
    navigate(routes.signin.make());
  };

  return (
    <Wrapper>
      <StyledIconWrapper>
        <PositiveIcon className="positiveIcon" />
      </StyledIconWrapper>
      <h1 className="great">Great!</h1>
      <h2 className="accountCreated">Your account has been created successfully.</h2>

      <ButtonMedium className="w-full" onClick={goToLogin}>
        Sign In
      </ButtonMedium>
    </Wrapper>
  );
};
